import { render } from "./calendarComponent.vue?vue&type=template&id=6563988c&scoped=true&bindings={\"month\":\"setup\",\"getNextMonth\":\"setup\",\"getPreviousMonth\":\"setup\"}"
import script from "./calendarComponent.vue?vue&type=script&lang=js"
export * from "./calendarComponent.vue?vue&type=script&lang=js"

import "./calendarComponent.vue?vue&type=style&index=0&id=6563988c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6563988c"

export default script